/**
 * Registers a new block provided a unique name and an object defining its behavior.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
import { registerBlockType } from '@wordpress/blocks';

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * All files containing `style` keyword are bundled together. The code used
 * gets applied both to the front of your site and to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './style.scss';


// // 	"render": "file:./render.php",
// 	"viewScript": "file:./view.js"
/**
 * Internal dependencies
 */
import edit from './edit';
import save from './save';
import json from './block.json';

const {name,...settings} = json;

/**
 * Every block starts by registering a new block type definition.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
registerBlockType( name, {
    ...settings,
	 /**
	  * @see ./edit.js
	  */
	 edit,
 
	 /**
	  * @see ./save.js
	  */
	 save,
 } );
